import { useCallback } from 'react';
import styled, { css } from 'styled-components';
import RangePicker, { type RangePickerFieldProps } from '../../../components/fields/RangePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import breakpoints from '../../../utilities/breakpoints';

export const RangePickerContainer = styled.div<{ $readOnly?: boolean }>`
    & .ant-form-item-label {
        padding-bottom: 4px;
    }
    & .ant-form-item-label > label {
        font-weight: 400;
    }

    & .ant-picker {
        height: 48px;
        padding: 8px;
        border: 1px solid rgb(98, 102, 105);
        border-radius: 0;

        outline: transparent solid 1px;
        outline-offset: 2px;

        & input {
            font-size: var(--input-font-size, 1rem);
        }

        & .ant-picker-range-separator {
            margin-left: -10px;
        }

        &.ant-picker-disabled {
            ${props =>
                props.$readOnly &&
                css`
                    background-color: #fff;

                    & .ant-picker-input > input[disabled] {
                        color: ${props => props.theme.antd['text-color']};
                        cursor: text;
                    }
                `}

            background-color: transparent;
            border-color: rgb(150, 152, 154);
            color: rgb(150, 152, 154);

            & .ant-picker-suffix {
                display: none;
            }
        }

        &:focus,
        &.ant-picker-focused {
            outline-color: rgb(98, 102, 105);
        }
    }
    & .ant-picker-active-bar {
        display: none;
    }

    & .ant-picker-status-error.ant-picker,
    & .ant-picker-status-error.ant-picker:not([disabled]):hover {
        border: 2px solid rgb(224, 0, 0);
    }

    & .ant-picker-status-error.ant-picker-focused {
        outline: rgb(224, 0, 0) solid 1px;
    }

    & .ant-picker-disabled {
        color: rgb(150, 152, 154);
        border-color: rgb(150, 152, 154);
    }

    @media screen and (min-width: ${breakpoints.md}) {
        .ant-picker-date-range-wrapper {
            min-width: 300px;
        }
    }
`;

const RangePickerWrapperContainer = styled.div`
    @media screen and (max-width: ${breakpoints.md}) {
        & .ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
            visibility: visible !important;
        }

        & .ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
            visibility: visible !important;
        }

        .ant-picker-panels > .ant-picker-panel:nth-child(2) {
            display: none;
        }

        & .ant-picker-panel-container,
        & .ant-picker-footer {
            width: 280px;
        }

        & .ant-picker-footer-extra > div {
            flex-wrap: wrap;
        }
    }
`;

type RangePickerProps = RangePickerFieldProps & { readOnly?: boolean };

const RangePickerField = ({ readOnly, ...props }: RangePickerProps) => {
    const panelRender = useCallback(
        panelNode => <RangePickerWrapperContainer>{panelNode}</RangePickerWrapperContainer>,
        []
    );

    return (
        <RangePickerContainer $readOnly={readOnly}>
            <RangePicker {...props} panelRender={panelRender} suffixIcon={<CalendarIcon />} />
        </RangePickerContainer>
    );
};

export default RangePickerField;
